import axios from "axios";
import {
  requestHandler,
  successHandler,
  errorHandler,
} from "./requestModifications";
// const ENV_VARIABLE = import.meta.env;
const ENV_VARIABLE = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api');
// console.log('🔧 API Base URL:', ENV_VARIABLE);

const httpRequest = (
  config = {
    headers: {
      contentType: "application/json",
    },
  }
) => {
  const instance = axios.create({
    baseURL: ENV_VARIABLE,
    headers: {
      "Content-Type": config.headers.contentType || "application/json",
    },
  });

  instance.interceptors.request.use(requestHandler);
  instance.interceptors.response.use(successHandler, errorHandler);
  return instance;
};
export default httpRequest();
